import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/aI_logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/data-collection-and-analysis/global_data_colection.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/products/AI/AI.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Header/index.tsx");
